import { FunctionComponent } from 'react';
import IconButton from '@mui/material/IconButton';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import MenuIcon from '@mui/icons-material/Menu';
import Tooltip from '@mui/material/Tooltip';
import { IToggleMenuButtonProps } from './ToggleMenuButton.interface';

export const ToggleMenuButton: FunctionComponent<IToggleMenuButtonProps> = (props) => {
  const { isExpanded, toggleExpanded } = props;

  const expandMenuActionText = 'Expand';
  const collapseMenuActionText = 'Collapse';

  return (
    <Tooltip
      title={`${isExpanded ? collapseMenuActionText : expandMenuActionText} menu`}
      enterDelay={1000}
    >
      <IconButton
        aria-label={`${isExpanded ? collapseMenuActionText : expandMenuActionText} navigation menu`}
        color={'inherit'}
        onClick={toggleExpanded}
        data-testid={'toggle-sidebar-drawer'}
      >
        {isExpanded ? <MenuOpenIcon /> : <MenuIcon />}
      </IconButton>
    </Tooltip>
  );
};
